<script setup lang="ts">
	import { useI18n } from 'vue-i18n';
	import { MonizzeLogo, MzHeader, MzLang, MzLayout } from '@monizze/monizze-components';
	import { useAuthStore } from '@/stores/auth.ts';
	import Logout from '@/pages/Logout.vue';
	import DynamicBreadcrumb from '@/components/DynamicBreadcrumb.vue';

	const { locale, fallbackLocale } = useI18n();
	const authStore = useAuthStore();

	const updateLocale = (newLocale: string): void => {
		locale.value = newLocale;
		if (authStore.isLux) {
			fallbackLocale.value = newLocale.substring(0, 2);
		}
	};
</script>

<template>
	<mz-layout variant="stacked" :sticky="false" :ui="{ main: 'flex items-center justify-center px-4 sm:px-8 lg:px-30 py-6' }">
		<template #header>
			<mz-header variant="bar" class="w-full px-4 sm:px-8 lg:px-30" :ui="{ innerHeader: 'justify-between' }">
				<template #left>
					<router-link to="/" class="self-center">
						<img v-if="authStore.isLux" src="/UpLux.svg" alt="" class="h-6 w-auto" />
						<monizze-logo v-else class="h-6 w-auto" />
					</router-link>
				</template>
				<template #right>
					<div class="flex items-center gap-4">
						<mz-lang :availables-locales="authStore.availableLanguages" @change="updateLocale" />
						<logout />
					</div>
				</template>
			</mz-header>
		</template>
		<div class="w-full max-w-[1200px] flex flex-col gap-6">
			<dynamic-breadcrumb />
			<router-view />
		</div>
	</mz-layout>
</template>
